export default __webpack_public_path__ + "static/media/date-harvest.cecaf0bf.svg";